var _g, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDesign3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 91,
    height: 91,
    viewBox: "0 0 91 91",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3401_4513)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.4849 19.9234C13.4849 12.7785 19.277 6.98633 26.422 6.98633H64.5478C71.6927 6.98633 77.4849 12.7785 77.4849 19.9234V58.0492C77.4849 65.1942 71.6927 70.9863 64.5478 70.9863H26.422C19.277 70.9863 13.4849 65.1942 13.4849 58.0492V19.9234Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.422 7.39061H64.5478C71.4694 7.39061 77.0806 13.0018 77.0806 19.9234V58.0492C77.0806 64.9709 71.4694 70.582 64.5478 70.582H26.422C19.5003 70.582 13.8891 64.9709 13.8891 58.0492V19.9234C13.8891 13.0018 19.5003 7.39061 26.422 7.39061Z",
    stroke: "#B1C1CF",
    strokeWidth: 0.808569
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.8081 31.4254C44.0021 31.4254 44.1882 31.5024 44.3255 31.6397C44.4627 31.7769 44.5398 31.963 44.5398 32.1571V39.9619H52.3447C52.5215 39.9619 52.6923 40.026 52.8256 40.1422C52.9588 40.2584 53.0455 40.419 53.0695 40.5941L53.0764 40.6936C53.0764 45.5424 49.1446 48.9863 44.2959 48.9863C41.9671 48.9863 39.7338 48.0612 38.0871 46.4146C36.4405 44.7679 35.5154 42.5346 35.5154 40.2058C35.5154 35.3571 38.9593 31.4254 43.8081 31.4254ZM43.0764 32.9249L42.8725 32.9483C39.2725 33.4068 36.9788 36.4819 36.9788 40.2058C36.9788 42.1464 37.7497 44.0076 39.1219 45.3798C40.4941 46.752 42.3553 47.5229 44.2959 47.5229C48.0198 47.5229 51.0939 45.2283 51.5544 41.6293L51.5759 41.4254H43.8081C43.6312 41.4253 43.4604 41.3613 43.3272 41.2451C43.1939 41.1289 43.1072 40.9683 43.0832 40.7932L43.0764 40.6936V32.9249ZM46.7349 28.9863C49.0636 28.9863 51.297 29.9114 52.9436 31.5581C54.5903 33.2047 55.5154 35.4381 55.5154 37.7668C55.5154 37.9609 55.4383 38.147 55.3011 38.2842C55.1638 38.4214 54.9777 38.4985 54.7837 38.4985H46.7349C46.5408 38.4985 46.3547 38.4214 46.2175 38.2842C46.0803 38.147 46.0032 37.9609 46.0032 37.7668V29.718C46.0032 29.524 46.0803 29.3379 46.2175 29.2006C46.3547 29.0634 46.5408 28.9863 46.7349 28.9863ZM47.4666 30.4858V37.0351H54.0149L53.9925 36.8312C53.7851 35.2271 53.0523 33.7368 51.9086 32.5931C50.7649 31.4494 49.2746 30.7166 47.6705 30.5093L47.4666 30.4858Z",
    fill: "#243251"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3401_4513",
    x: 0.547752,
    y: 0.517773,
    width: 89.8742,
    height: 89.8742,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6.46856
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.46856
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.615686 0 0 0 0 0.686275 0 0 0 0 0.776471 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3401_4513"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3401_4513",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesign3);
export default __webpack_public_path__ + "static/media/Design3.9039a5a3ebf550ef80da08ca034c20b8.svg";
export { ForwardRef as ReactComponent };